<template>
  <el-form ref="form" class="login-form" label-position="top" :model="form" :rules="rules">
    <el-form-item prop="email" :label="$t('ec-line029.loginForm.email')">
      <el-input
        type="text"
        v-model="form.email"
        autocomplete="new-password"
        :placeholder="$t('ec-line029.loginForm.emailPlaceholder')"
      ></el-input>
    </el-form-item>
    <el-form-item prop="password" :label="$t('ec-line029.loginForm.pass')">
      <el-input
        type="password"
        v-model="form.password"
        autocomplete="new-password"
        :placeholder="$t('ec-line029.loginForm.passPlaceholder')"
      ></el-input>
    </el-form-item>
    <div class="w-full mx-auto text-center">
      <el-button class="submit-btn login-button" @click="onSubmit">
        {{ $t('ec-line031.content.form.loginWithEmail') }}
      </el-button>
    </div>
    <div class="flex justify-center mt-2">
      <span class="text-xs text-primary-50 underline cursor-pointer" @click="onForgotPassword">{{
        $t('ec-line029.loginForm.forgetPass')
      }}</span>
    </div>
  </el-form>
</template>
<script>
export default {
  name: 'LoginForm',
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      rules: {
        email: [
          this.Utils.validate.required(this.$t('common.validate.field.email')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.email')),
        ],
        password: [
          this.Utils.validate.required(this.$t('common.validate.field.password')),
          this.Utils.validate.password(this.$t('common.validate.field.password')),
        ],
      },
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return

        this.$emit('on-login', this.form)
      })
    },
    onForgotPassword() {
      this.$router.push(this.$routePage.EC_LINE032)
    },
  },
}
</script>
<style lang="scss">
@import '@/assets/css/components/ec-line029/login-form.scss';
</style>
